import React, { useState, useEffect } from "react";
import { Select, LabelWithContainer, Label, ErrorMessage } from "./FormStyles";
import Spinner from "../Common/Spinner";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import { validationSchemaRequired } from "../../utils/SchemaValidations";
import { isEmptyValue } from "../../utils/StringUtil";

const CustomSelect = ({
  options,
  label,
  value,
  showDefaultOption,
  onChange,
  width,
  height,
  disabled,
  required,
  dataLoading,
  showRequired,
  labelColor,
  labelWeight,
  errorMessage,
  isLabelWithContainer,
  labelWidth,
  labelHeight,
  testid
}) => {
  const empresa = useEmpresa();

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (required && showRequired && isEmptyValue(value)) {
      requireField();
    }
  }, [showRequired]); // eslint-disable-line react-hooks/exhaustive-deps

  const validate = async (valueField) => {
    try {
      if (required) {
        await validationSchemaRequired.validate({
          requiredField: valueField,
        });
      }
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const requireField = async () => {
    try {
      await validationSchemaRequired.validate({
        requiredField: null,
      });
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
    validate(selectedValue);
  };

  return (
    <>
      <CheckRender allowed={label}>
        <CheckRender allowed={isLabelWithContainer}>
          <div>
            <LabelWithContainer
              font={empresa?.LETRA_PRINCIPAL}
              labelWidth={labelWidth}
              labelHeight={labelHeight}
            >
              {required ? `* ${label}` : label}
            </LabelWithContainer>
          </div>
        </CheckRender>
        <CheckRender allowed={!isLabelWithContainer}>
          <Label
            font={empresa?.LETRA_PRINCIPAL}
            color={labelColor}
            weight={labelWeight}
          >
            {required ? `* ${label}` : label}
          </Label>
        </CheckRender>
      </CheckRender>

      <CheckRender allowed={dataLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>

      <CheckRender allowed={!dataLoading}>
        <Select
          value={value || ''}
          onChange={handleChange}
          font={empresa?.LETRA_PRINCIPAL}
          width={width}
          height={height}
          disabled={disabled}
          testid={testid}
        >
          {showDefaultOption && (
            <option key={0} value={""}>
              {"Seleccionar"}
            </option>
          )}
          {options.map((option) => (
            <option 
              key={option.value} 
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </Select>
      </CheckRender>
      {errors.requiredField && (
        <ErrorMessage>{errors.requiredField}</ErrorMessage>
      )}
      {errorMessage && !errors.requiredField && (
        <ErrorMessage>{errorMessage}</ErrorMessage>
      )}
    </>
  );
};

export default CustomSelect;
